import { SimpleCard, Table, TableBody, TableCell, TableRow, } from '@pinwheel/origami';
import React from 'react';
import Divider from '../../../components/Divider';
import { TableLabelCell, TableValueCell } from './TableUtils';
var EmptyRow = function () { return (React.createElement(TableRow, null,
    React.createElement(TableCell, { colSpan: 2 },
        React.createElement(Divider, null)))); };
var DetailsTable = function (_a) {
    var data = _a.data;
    return (React.createElement(SimpleCard, null,
        React.createElement(Table, null,
            React.createElement(TableBody, null, data.map(function (detail, i) {
                return detail ? (React.createElement(TableRow, { key: "DetailsTableRow-".concat(i) },
                    React.createElement(TableLabelCell, null, detail.label),
                    React.createElement(TableValueCell, null, detail.value))) : (React.createElement(EmptyRow, { key: "DetailsTableRow-".concat(i) }));
            })))));
};
export default DetailsTable;
